<template>
  <div
    class="app-container"
    v-loading="openloading"
    element-loading-text="加载中"
    element-loading-background="rgba(0, 0, 0, 0.2)"
  >
    <el-row style="padding-bottom: 15px;">
      <el-col :span="24">
        <h3 class="headtitle">云供应链单据</h3>
        <span>business document</span>
      </el-col>
    </el-row>
    <el-card>
      <el-form label-width="120px" label-position="left">
        <el-row :gutter="20">
          <el-col :span="14" style="position:relative">
            <el-form-item label="单据时间">
              <el-date-picker
                v-model="timeSpan"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="right"
                style=" width:100%"
                @change="timechange"
              ></el-date-picker>
              <!-- <DateRangePicker
                :onChange="initData"
                :start.sync="fetchParams.startTime"
                :end.sync="fetchParams.endTime"
              ></DateRangePicker>-->
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-select
              placeholder="请选择财务软件"
              value-key="id"
              v-model="choosedAccount"
              @change="changeValue"
            >
              <el-option
                v-for="item in AccountDatas"
                :key="item.id"
                :label="item.name"
                :value="item"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-button
              @click="gobusinessorder"
              type="primary"
              icon="el-icon-refresh"
              class="pull-right right-15"
              size="medium"
            >同步</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div style=" width:100%; height:20px"></div>
      <el-table :data="tableData" size="mini" style="width: 100%;" border>
        <el-table-column prop="billNO" label="单据号"></el-table-column>
        <el-table-column prop="billType" label="单据类型"></el-table-column>
        <el-table-column prop="billBusType" label="业务类型"></el-table-column>
        <el-table-column prop="itemName" label="品项名称"></el-table-column>
        <el-table-column prop="mainUnit" label="品项单位"></el-table-column>
        <el-table-column prop="itemSpec" label="品项规格"></el-table-column>
        <el-table-column label="单据日期">
          <template slot-scope="scope">
            <i :class="scope.row.color" style="margin-right: 10px;"></i>
            {{dateFormat(scope.row.busDate)}}
          </template>
        </el-table-column>
        <el-table-column label="出入库">
          <template slot-scope="scope">
            <i v-if="scope.row.isOut">出库</i>
            <i v-else>入库</i>
          </template>
        </el-table-column>
        <el-table-column label="数量">
          <template slot-scope="scope">
            <i v-if="scope.row.isOut">{{scope.row.outMainAmount}}</i>
            <i v-else>{{scope.row.inMainAmount}}</i>
          </template>
        </el-table-column>
        <el-table-column label="金额">
          <template slot-scope="scope">
            <i v-if="scope.row.isOut">{{scope.row.outStoreMoney}}</i>
            <i v-else>{{scope.row.inStoreMoney}}</i>
          </template>
        </el-table-column>
      </el-table>
      <pagerBar
        ref="cloundApiUrl"
        :apiURL="cloundApiUrl"
        :GetData="initData"
        :queryParam="queryParam"
        :isInit="true"
        :errorFunc="CloseError"
        :beforeData="BeforeData"
      ></pagerBar>
    </el-card>
  </div>
</template>

<script>
import axios from "axios";
import config from "@/common/config.js";
import pagerBar from "@/views/pager/pagerBar";
import AjaxHelper from "@/common/js/AjaxHelper";
import moment from "moment";
import { DatePicker } from "element-ui";
import DateRangePicker from "../../components/daterange/DateRangePicker";

export default {
  components: {
    pagerBar,
    DateRangePicker
  },
  data() {
    return {
      openloading: true,
      cloundApiUrl: config.BASE_Middle_API + "CloudSupply/GetList",
      Visible: false,
      color: "",
      tableData: [],

      timeSpan: [new moment().add(-1, "days"), new moment()],
      queryParam: {
        startTime: new moment().add(-1, "days").format("YYYY-MM-DD"),
        endTime: new moment().format("YYYY-MM-DD")
      },
      AccountDatas: [
        // { name: "哗啦啦财务软件", id: "1" },
        { name: "餐饮财务管理系统", id: "1" },
        { name: "KIS账务平台", id: "2" }
      ],
      value: "",
      selectUser: false,
      filterText: "",
      choosedAccount: {},
      choosedID: ""
    };
  },
  created() {
    this.startDate = moment().startOf("day");
    this.endDate = moment().endOf("day");
  },
  mounted: function() {
    //this.initData();
  },
  methods: {
    gobusinessorder() {
      if (this.tableData.length == 0) {
        this.$notify({
          title: "提示",
          message: "当前日期范围内没有数据，请重新选择日期",
          type: "error",
          position: "bottom-right"
        });
        return;
      }
      if (this.choosedID == "") {
        this.$notify({
          title: "提示",
          message: "请先选择财务软件",
          type: "error",
          position: "bottom-right"
        });
        return;
      }
      let targetPath = "businessorder";
      if (this.choosedID == "2") {
        targetPath = "kisorder";
      }
      this.$router.push({
        path: targetPath,
        query: this.queryParam
      });
    },
    changeValue() {
      this.choosedID = this.choosedAccount.id;
    },
    dateFormat(val) {
      return moment(val).format("YYYY-MM-DD");
    },
    timechange(val) {
      let startTime = moment(val[0]).format("YYYY-MM-DD");
      let endTime = moment(val[1]).format("YYYY-MM-DD");
      this.queryParam = {
        startTime: startTime,
        endTime: endTime
      };
      this.initData();
    },
    initData(data) {
      this.tableData = data;
      this.openloading = false;
    },
    CloseError() {
      this.openloading = false;
    },
    BeforeData() {
      this.openloading = true;
    },
    Refresh() {
      this.$refs.refPagerBar.Refresh();
    }
  }
};
</script>

<style scoped>
.minicard {
  height: auto !important;
  display: block;
  width: 200px;
  position: absolute;
  right: 0;
  z-index: 9989;
  top: 80px;
}
.minicard .el-button {
  width: 150px;
  margin: 5px 0;
}
.el-dialog__body {
  padding: 10px 15px !important;
}

dl.loglist p {
  font-weight: 600;
  margin: 20px 0 10px 0;
}
dl.loglist dd {
  padding: 15px 0;
  color: #999999;
  display: block;
}
dl,
dt,
dd {
  margin: 0;
  padding: 0;
}
.w25 {
  width: 25%;
  float: left;
}
.w75 {
  width: 75%;
  float: left;
}
</style>